"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FoursquareSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FoursquareSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "FourSquare"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "foursquare-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M81.429,7.5H18.571A11.084,11.084,0,0,0,7.5,18.571V81.429A11.084,11.084,0,0,0,18.571,92.5H81.429A11.084,11.084,0,0,0,92.5,81.429V18.571A11.084,11.084,0,0,0,81.429,7.5ZM87.5,81.429A6.079,6.079,0,0,1,81.429,87.5H18.571A6.079,6.079,0,0,1,12.5,81.429V18.571A6.079,6.079,0,0,1,18.571,12.5H81.429A6.079,6.079,0,0,1,87.5,18.571Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M61.411,29H39A3.8,3.8,0,0,0,34.9,32.782V68.371A2.431,2.431,0,0,0,36.4,70.84a2.529,2.529,0,0,0,2.7-.582C49.671,58,49.851,57.8,49.851,57.8c.255-.279.279-.255.558-.255h6.842c2.88,0,3.331-2.067,3.635-3.257l3.987-19.935C65.57,30.87,64.692,29,61.411,29Zm-1.338,6.055-.935,4.9a1.543,1.543,0,0,1-1.386,1.083H49.023a1.609,1.609,0,0,0-1.69,1.666v1.066a1.628,1.628,0,0,0,1.69,1.69h7.416a1.321,1.321,0,0,1,1.214,1.493c-.147.73-.861,4.414-.935,4.824a1.463,1.463,0,0,1-1.386,1.108H49.3a2.213,2.213,0,0,0-2.174,1.033s-.73.936-7.343,8.885c-.074.074-.147.049-.147-.024V34.981A1.406,1.406,0,0,1,41,33.619H58.966A1.16,1.16,0,0,1,60.073,35.055Z"
  })))));
}